package com.anjuros.website.templates.template8.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.language.LocalText


import com.anjuros.website.templates.selection.styles.HeaderHeight

import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.components.Template8Header
import com.anjuros.website.templates.template8.components.Template8WhatsOnCard
import com.anjuros.website.templates.template8.modules.Template8WhatsOn
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.Template8WhatsOnTitleTextStyle
import com.anjuros.website.templates.template8.styles.getColor
import com.anjuros.website.templates.template8.util.ResKey
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8WhatsOnSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    onMenuCLicked: () -> Unit
) {
    Box(
        modifier = modifier
            .backgroundColor(Template8Theme.Gold2.rgb)
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template8Header(onMenuCLicked=onMenuCLicked)
            GoldLine()

            Template8WhatOn()
        }
        AnjurosLogo(
            modifier = Modifier

                .align(Alignment.TopCenter)
                .margin(top = 20.px)
                .size(150.px)
                .objectFit(ObjectFit.ScaleDown),
            src = Template8Res.Image.template8_logo,
            alt = "Pub menu"
        )

    }
}

@Composable
fun Template8WhatOn() {

    var animatedTranslateX = remember { mutableStateListOf(Template8WhatsOn.entries[0].animatedTranslateX) }
    var animatedTranslateY = remember { mutableStateListOf(Template8WhatsOn.entries[0].animatedTranslateY) }
    var scope = rememberCoroutineScope()
    var breakpoint = rememberBreakpoint()
    var scale = if(breakpoint>=Breakpoint.LG) 1.0 else 0.3

    repeat(Template8WhatsOn.entries.size-1){ index ->
        animatedTranslateY.add(Template8WhatsOn.entries[index+1].animatedTranslateY)
        animatedTranslateX.add(Template8WhatsOn.entries[index+1].animatedTranslateX)

    }
    scope.launch {
        delay(400)
        Template8WhatsOn.entries.forEach { item ->
            animatedTranslateY[item.ordinal] = 0.percent
            animatedTranslateX[item.ordinal] = 0.percent

        }
    }


    Box(
        modifier = Modifier.fillMaxWidth()
            .margin(top = 150.px)

    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .align(Alignment.Center),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            P(
                attrs = Template8WhatsOnTitleTextStyle.toModifier()
                    .fontFamily(FONT_FAMILY)
                    .fontWeight(FontWeight.Normal)
                    .color(Template8Theme.Primary.getColor())
                    .toAttrs()
            ) {

                Text(LocalText(ResKey.TEMPLATE8_SERVICE4_TITLE0))

            }
            SimpleGrid(
                numColumns = numColumns(base = 1, md = 2),
                modifier = Modifier.fillMaxWidth(80.percent)
                ) {
                Template8WhatsOn.entries.forEach { template8whatson ->
                    Box(
                        modifier = Modifier.fillMaxWidth(),
                        contentAlignment = Alignment.Center
                    ) {
                        Template8WhatsOnCard(
                            template8WhatsOn = template8whatson,
                            animatedTranslateX = animatedTranslateX[template8whatson.ordinal]*scale,
                            animatedTranslateY = animatedTranslateY[template8whatson.ordinal]*scale
                        )
                    }


                }
            }
        }

    }
}